"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentSearchInfoDiv = exports.RecentItemDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const imageUrl_1 = require("../../../resource/imageUrl");
exports.RecentItemDiv = styled_components_1.default.div `
  height: ${(props) => props.height}px;

  .Recent__Query__Item {
    display: flex;
    align-items: center;
    gap: 14px;

    width: 100%;
    height: 100%;

    padding: 0 20px;
  }

  .Recent__Query__Item:focus {
    background-color: #eaeaea;

    .Vertical__Focus {
      background-color: #0ac7ce;
    }
  }

  .Recent__Query__Item__Img {
    position: relative;
    top: 1px;

    width: 15px;
    height: 15px;
  }

  .Recent__Search__Query__Content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;

    text-align: left;
    font-size: 0.9375rem;
    letter-spacing: -0.0469rem;
    color: #202020;
  }

  &:hover {
    background-color: #eaeaea;

    .Vertical__Focus {
      background-color: #0ac7ce;
    }
  }
`;
exports.RecentSearchInfoDiv = styled_components_1.default.div `
  display: flex;
  align-items: ${(props) => props.align};

  height: 41px;
  padding-top: ${(props) => props.padtop}px;

  .Recent__Info__Time {
    display: flex;
    align-items: center;
    gap: 18px;

    font-size: 0.875rem;
    letter-spacing: -0.0437rem;
    color: #9e9e9e;

    .Recent__Info__Remove {
      position: relative;
      top: -1px;

      display: flex;
      justify-content: center;
      align-items: center;

      width: 10px;
      height: 10px;

      span {
        position: absolute;

        width: 12.5px;
        height: 12.5px;

        background-image: url(${imageUrl_1.search_input.close_img});
        background-size: 10px 10px;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }
`;
